import styled from '@emotion/styled'

import { calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'
import { metrics } from 'component-library/__styling/settings'

import { TextItem } from 'component-library/typography/TextItem/TextItem'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledParagraph = styled(TextItem)(({ theme }) => ({
    ...breakWords,
    margin: themedValue(theme, {
        thewest: `0 0 ${calcRem(metrics.thewest.textMargin / 2)} 0`,
        perthnow: `0 0 ${calcRem(metrics.perthnow.textMargin)} 0`,
        sevennews: `0 0 ${calcRem(metrics.sevennews.textMargin)} 0`,
    }),
    lineHeight: themedValue(theme, {
        thewest: 1.65,
        perthnow: 1.5,
        sevennews: 1.7,
    }),
}))
